import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faArrowAltCircleRight,
  faArrowAltCircleDown,
  faTimesCircle,
  faCompass,
  faAddressBook,
  faBuilding,
  faFileAlt,
  faCalendarAlt,
  faNewspaper
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faArrowAltCircleRight,
  faArrowAltCircleDown,
  faTimesCircle,
  faCompass,
  faAddressBook,
  faBuilding,
  faFileAlt,
  faCalendarAlt,
  faNewspaper
);